"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = apiReducer;
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _Actions = require("./Actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  sources: {},
  isFetching: false
};
function getSourceState(action) {
  switch (action.type) {
    case _Actions.REQUEST_DATA:
      return {
        isFetching: true,
        source: action.source
      };
    case _Actions.POST_DATA:
      return {
        isFetching: true,
        isPosted: true,
        postData: action.data,
        source: action.source
      };
    case _Actions.NETWORK_ERROR:
      return {
        isFetching: false,
        error: action.error,
        source: action.source
      };
    case _Actions.REQUEST_ERROR:
      return {
        isFetching: false,
        error: action.error,
        source: action.source
      };
    case _Actions.RECEIVE_DATA:
      return {
        isFetching: false,
        data: action.data,
        source: action.source
      };
    case _Actions.CANCEL_REQUEST:
      return {
        isFetching: false,
        isCancelled: true,
        source: action.source
      };
  }
}
function apiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case _Actions.REQUEST_DATA:
    case _Actions.POST_DATA:
    case _Actions.NETWORK_ERROR:
    case _Actions.RECEIVE_DATA:
    case _Actions.CANCEL_REQUEST:
    case _Actions.REQUEST_ERROR:
      {
        var sourceState = getSourceState(action);
        var sources = _objectSpread({}, state.sources);
        var key = (0, _isObject["default"])(action.source) ? action.source.url : action.source;
        if (sourceState.isFetching) {
          sources[key] = sourceState;
        } else {
          // remove when fetching finished... maybe it saves a bit of memory
          delete sources[key];
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          sources: sources,
          isFetching: (0, _reduce["default"])(sources, function (result, value) {
            return result || value.isFetching;
          }, false)
        });
      }
    default:
      return state;
  }
}